<app-modal-wrap
	(onClose)="preClose()"
	[modalWrapperClass]="isAreasOpen ? 'modal-1200' : 'modal-fit-content'"
	title="preview"
>
	<app-spin-or-content [isSpin]="!(headtureRow && finresourceObj)">
		<div class="d-flex gap-5">
			@if (isDemoMode || isAreasOpen) {
				<div style="width: 500px">
					<table class="area-matrix">
						<tbody>
							@for (row of areaLocs; track row) {
								<tr>
									@for (item of row; track item) {
										<td
											valign="center"
											align="center"
										>
											@if (item) {
												<div>
													<div (click)="arrowMove(item, 'up')">↑</div>
													<div>
														<div (click)="arrowMove(item, 'back')">→</div>
														<div>
															{{
																$safeNavigationMigration(item?.area) | langVal
															}}
															@if (item?.error) {
																<p class="error">{{ item.error }}</p>
															}
														</div>
														<div (click)="arrowMove(item, 'for')">←</div>
													</div>
													<div (click)="arrowMove(item, 'down')">↓</div>
												</div>
											}
										</td>
									}
								</tr>
							}
						</tbody>
					</table>
					<div
						class="row"
						style="margin-top: 10px"
					>
						<div class="col-12">
							<app-btn-ext
								text="save"
								(clickEv)="saveAreas()"
								[disabled]="areasStructureError"
								[isSpin]="areaSaving"
							/>
						</div>
					</div>
				</div>
			}

			<div id="preview-finresource">
				<div
					[style.font-family]="font"
					[dir]="isEn ? 'ltr' : 'rtl'"
				>
					@if (
						finresourceObj?.medical_conf == "yes" || doctype == "prescription"
					) {
						<div style="text-align: center">{{ curLang?.medical_conf }}</div>
					}

					@for (areaRow of areaRows; track areaRow) {
						@if (
							finresourceObj?.images?.length &&
							(areaRow[0]?.area == "signature" ||
								areaRow[1]?.area == "signature")
						) {
							<div>
								@for (image of finresourceObj.images; track image) {
									<div class="followup-image-div">
										<img
											[src]="image.id | serverImg: 'followup-image'"
											class="followup-image mb20"
										/>
									</div>
								}
							</div>
						}
						@if (areaRow.length == 2) {
							<table class="areaRow">
								<tbody>
									<tr>
										<td
											style="width: 66%"
											valign="top"
										>
											<ng-container
												*ngTemplateOutlet="
													areaTemplate;
													context: { area: areaRow[0].area }
												"
											/>
										</td>
										<td
											style="width: 33%"
											valign="top"
											[style.text-align]="
												areaRow[0].area == 'date' ? 'center' : ''
											"
										>
											<ng-container
												*ngTemplateOutlet="
													areaTemplate;
													context: { area: areaRow[1].area }
												"
											/>
										</td>
									</tr>
									@if (
										(areaRow[0].area == "title" ||
											areaRow[1].area == "title") &&
										doctype != "document"
									) {
										<tr>
											<td colspan="2">
												<hr />
											</td>
										</tr>
									}
								</tbody>
							</table>
						}
						@if (areaRow.length == 1) {
							@if (areaRow[0].position != 2) {
								<div
									[style.text-align]="areaRow[0].position == 1 ? 'center' : ''"
									class="areaRow"
									[class.wide-logo]="
										areaRow[0].position == 1 &&
										areaRow[0].area === 'logo' &&
										isLogoWide
									"
								>
									<ng-container
										*ngTemplateOutlet="
											areaTemplate;
											context: { area: areaRow[0].area }
										"
									/>
									@if (areaRow[0].area == "title" && doctype != "document") {
										<hr />
									}
								</div>
							}
							@if (areaRow[0].position == 2) {
								<table class="areaRow">
									<tbody>
										<tr>
											<td
												style="width: 66%"
												valign="top"
											></td>
											<td
												style="width: 33%"
												valign="top"
												[style.text-align]="
													areaRow[0].area == 'date' ? 'center' : ''
												"
											>
												<ng-container
													*ngTemplateOutlet="
														areaTemplate;
														context: { area: areaRow[0].area }
													"
												/>
											</td>
										</tr>
										@if (areaRow[0].area == "title" && doctype != "document") {
											<tr>
												<td colspan="2">
													<hr />
												</td>
											</tr>
										}
									</tbody>
								</table>
							}
						}
					}
				</div>
			</div>
		</div>

		@if (!isDemoMode) {
			<div class="modal-btns">
				<app-cancel-btn (click)="preClose()" />

				@if (doctype == "document") {
					<app-btn-ext
						text="design_your_document"
						(clickEv)="isAreasOpen = true"
					/>

					@if (finresourceObj?.for_signing != "yes") {
						<app-btn-ext
							text="save_only"
							(clickEv)="saveOnly()"
							[isSpin]="isSaving"
						/>
					}
					@if (
						permsService?.owner_has_users &&
						!permsService.perms?.authorized_signer &&
						!permsService.perms?.signer
					) {
						<app-btn-ext
							text="serve_for_signing"
							(clickEv)="saveOnly(true)"
							[isSpin]="isSaving"
						/>
						<!-- "doctype"=='document' only authorized_signer can sign it-->
					}
				}

				@if (
					!permsService?.owner_has_users ||
					doctype != "document" ||
					(doctype == "document" &&
						(permsService.perms?.authorized_signer ||
							permsService.perms?.signer))
				) {
					<app-btn-ext
						text="save_and_print"
						(clickEv)="downloadNewWnd()"
						[isSpin]="isSaving"
					/>
					<app-btn-ext
						text="save_and_download"
						(clickEv)="download()"
						[isSpin]="isSaving"
					/>

					<div class="d-flex flex-nowrap">
						<app-btn-ext
							text="send_by_email"
							(clickEv)="openContactwaysModal()"
							[isSpin]="isSaving"
						/>
						@if (
							finresourceObj.patient_id &&
							(doctype | inArray: ["proforma", "justinvoice"])
						) {
							<app-btn-dropdown
								class="dropdown-container"
								iconName="arrow_up"
								(onChoose)="handleSendOption($event)"
								[options]="sendOpts"
							/>

							<!-- OLD SMS AND WHATSAPP BUTTONS -->
							<!-- <app-btn-ext
					text="send_sms_proforma1"
					(clickEv)="sendSms()"
					[isSpin]="isSaving"
				/>
				<app-btn-ext
					text="send_whatsapp_proforma"
					(clickEv)="download({ getWhatsappLink: true })"
					[isSpin]="isSaving"
				/> -->
							<!-- END OF OLD SMS AND WHATSAPP BUTTONS -->

							<!--        <app-btn-ext-->
							<!--					text="open_payment_terminal"-->
							<!--					(clickEv)="download({ openPaymentTerminal: true })"-->
							<!--					[isSpin]="isSaving"-->
							<!--				/>-->
						}
					</div>
				}
			</div>
		}
	</app-spin-or-content>
</app-modal-wrap>
<ng-template
	#areaTemplate
	let-area="area"
>
	@switch (area) {
		@case ("logo") {
			@if (headtureRow.logo) {
				<img
					id="template-logo-pic"
					class="logo-img"
					[src]="headtureRow.id | serverImg: 'headture-logo'"
					[alt]="'logo' | langVal"
				/>
			}
		}
		@case ("headerText") {
			<div
				class="header-span"
				[innerHTML]="headtureRow.header_text | safeHtml"
			></div>
		}
		@case ("title") {
			<div>
				@if (doctype == "document") {
					@if (finresourceObj.show_title === "yes") {
						<span id="title-text-document"
							>{{ curLang?.reg }}:
							{{ finresourceObj?.title_dec || finresourceObj.title }}</span
						>
					}
				} @else {
					<b id="title-text">
						@if (doctype == "proforma" && finresourceObj.patient_id) {
							{{ curLang?.proforma_to_patient }}
						} @else {
							{{ curLang[doctype] || doctype }}
						}
						: {{ finresourceObj.id }}
					</b>
				}
			</div>
		}
		@case ("date") {
			@if (doctype | inArray: ["prescription", "document"]) {
				<div>{{ finresourceObj.date || today | dateFormat }}</div>
			} @else {
				<div id="date-text">
					{{ finresourceObj.created_at || today | dateFormat }}
				</div>
			}
		}
		@case ("for") {
			@if (
				(finresourceObj.paid_by?.length || finresourceObj.paid_by_dec) &&
				(doctype | inArray: ["invoice", "receipt", "selfinvoice"])
			) {
				<div class="for">
					{{ curLang?.paid_by }}:
					{{ finresourceObj.paid_by_dec || finresourceObj.paid_by }}
				</div>
			}
			@if (
				doctype
					| inArray
						: [
								"justinvoice",
								"admininvoice",
								"credit_admininvoice",
								"credit_justinvoice",
								"credit_invoice",
								"credit_receipt",
						  ]
			) {
				<div class="for">
					{{ curLang?.to }}:
					{{ finresourceObj.paid_by_dec || finresourceObj.paid_by }}
				</div>
			}
			@if (
				doctype
					| inArray
						: [
								"invoice",
								"receipt",
								"selfinvoice",
								"justinvoice",
								"admininvoice",
								"credit_admininvoice",
								"credit_justinvoice",
								"credit_invoice",
								"credit_receipt",
						  ]
			) {
				<div class="for">
					@if (finresourceObj.id_number) {
						<div>{{ curLang?.id_number }} {{ finresourceObj.id_number }}</div>
					}
					@if (address) {
						<div>{{ address }}</div>
					}
					@if (bn_number) {
						<div>{{ curLang?.bn_number }} {{ bn_number }}</div>
					}
				</div>
			}

			@switch (doctype) {
				@case ("proforma") {
					<div class="for">
						@if (finresourceObj.patient_id) {
							<div class="for">
								{{ finresourceObj.for }} {{ curLang?.hello }},
							</div>
							@if (finresourceObj.id_number) {
								<div class="notfor">
									{{ curLang?.id_number }} {{ finresourceObj.id_number }}
								</div>
							}
							<div class="for">
								{{ finresourceObj.attached_summary_text }}, <br />{{
									curLang?.for
								}}:
								{{
									finresourceObj.description_dec || finresourceObj.description
								}}
							</div>
						} @else {
							<div class="for">
								{{ curLang?.to }}:
								{{ finresourceObj.for }}
							</div>
							@if (address) {
								<div class="notfor">{{ address }}</div>
							}
							@if (bn_number) {
								<div class="notfor">
									{{ curLang?.bn_number }} {{ bn_number }}
								</div>
							}
							<div class="for">
								{{ curLang?.for }}:
								{{
									finresourceObj.description_dec || finresourceObj.description
								}}
							</div>
						}
					</div>
				}
				@case ("document") {
					<div class="for">
						@if (finresourceObj.recipient_dec || finresourceObj.recipient) {
							{{ curLang?.to }}:
						}
						{{ finresourceObj.recipient_dec || finresourceObj.recipient }}
					</div>
				}
			}

			@if (
				!(
					doctype
					| inArray
						: [
								"credit_admininvoice",
								"credit_justinvoice",
								"credit_invoice",
								"credit_receipt",
								"document",
								"prescription",
								"proforma",
						  ]
				)
			) {
				<div class="for">
					{{ curLang?.for }}:
					{{ finresourceObj.description_dec || finresourceObj.description }}
				</div>
			}
			@if (
				doctype
					| inArray
						: [
								"credit_admininvoice",
								"credit_justinvoice",
								"credit_invoice",
								"credit_receipt",
						  ]
			) {
				<div class="for">
					{{ finresourceObj.description_dec || finresourceObj.description }}
				</div>
			}
			@if (doctype == "prescription") {
				<div class="for">
					<b class="for"
						>{{ finresourceObj.patient_name }}
						{{ curLang?.id_number_short }}
						{{ finresourceObj.patient_id_number }}</b
					>
					<br />
					{{ finresourceObj.address }}
					@if (finresourceObj.age && finresourceObj.age < 18) {
						<div>{{ curLang?.age }} {{ finresourceObj.age }}</div>
					}
				</div>
			}

			@if (finresourceObj.justinvoice_id) {
				<div class="for">
					{{ curLang?.against_justinvoice }}:
					<span
						style="direction: ltr"
						class="for"
						>{{ finresourceObj.justinvoice_id }}</span
					>
				</div>
			}
			@if (finresourceObj.proforma_id) {
				<div class="for">
					{{ curLang?.against_proforma }}:
					<span
						style="direction: ltr"
						class="for"
						>{{ finresourceObj.proforma_id }}</span
					>
				</div>
			}
			@if (finresourceObj.proforma_ids?.length) {
				<div class="for">
					{{
						finresourceObj.proforma_ids.length == 1
							? curLang?.against_proforma
							: curLang?.against_proformas
					}}:
					<span
						style="direction: ltr"
						class="for"
						>{{ finresourceObj.proforma_ids.join(", ") }}</span
					>
				</div>
			}
			@if (finresourceObj.receipt_ids?.length) {
				<div class="for">
					{{
						finresourceObj.receipt_ids.length == 1
							? curLang?.against_receipt
							: curLang?.against_receipts
					}}:
					<span
						style="direction: ltr"
						class="for"
						>{{ finresourceObj.receipt_ids.join(", ") }}</span
					>
				</div>
			}
			@if (finresourceObj.justinvoice_ids?.length) {
				<div class="for">
					{{
						finresourceObj.justinvoice_ids.length == 1
							? curLang?.against_justinvoice
							: curLang?.against_justinvoices
					}}:
					<span
						style="direction: ltr"
						class="for"
						>{{ finresourceObj.justinvoice_ids.join(", ") }}</span
					>
				</div>
			}
			@if (finresourceObj.receipt_id) {
				<div class="for">
					{{ curLang?.against_receipt }}:
					<span
						style="direction: ltr"
						class="for"
						>{{ finresourceObj.receipt_id }}</span
					>
				</div>
			}
			@if (
				finresourceObj.totalMinusvat >= 5000 && doctype
					| inArray: ["invoice", "justinvoice", "receipt"]
			) {
				<div class="for">
					{{ curLang?.israel_invoice }}:
					<span
						style="direction: ltr"
						class="for"
						>{{ curLang?.will_appear_here }}</span
					>
				</div>
			}
		}
		@case ("table") {
			<div style="text-align: start">
				@if (
					doctype
						| inArray
							: [
									"credit_invoice",
									"credit_admininvoice",
									"credit_justinvoice",
									"credit_receipt",
							  ]
				) {
					<hr class="mb20" />
					<table>
						<tbody>
							<tr>
								<td>{{ curLang?.totalMinusvat }} :</td>
								<td class="display-number emp-number">
									{{ finresourceObj.totalMinusvat | finNumber }}
								</td>
							</tr>
							<tr>
								<td>{{ curLang?.vat }} {{ vatPerc }}% :</td>
								<td class="display-number">
									{{ finresourceObj.vat }}
								</td>
							</tr>
							<tr>
								<td>{{ curLang?.total }} :</td>
								<td class="display-number emp-number">
									{{ finresourceObj.total }}
								</td>
							</tr>
						</tbody>
					</table>
				}

				@if (
					!(
						doctype
						| inArray
							: [
									"credit_invoice",
									"credit_admininvoice",
									"credit_justinvoice",
									"credit_receipt",
									"document",
									"prescription",
							  ]
					)
				) {
					<div
						style="margin-bottom: 10px"
						[innerHTML]="
							finresourceObj.payment_details_dec ||
								finresourceObj.payment_details | safeHtml
						"
					></div>
				}

				@if (
					finresourceObj.invoicelines &&
					finresourceObj.invoicelines?.length &&
					(doctype
						| inArray: ["invoice", "admininvoice", "receipt", "selfinvoice"])
				) {
					<table>
						<thead>
							<tr class="highlight">
								<th>
									{{ curLang?.payment }}
								</th>
								<th>{{ curLang?.bank }}/{{ curLang?.credit_card }}</th>
								<th>
									{{ curLang?.account }}
								</th>
								<th>{{ curLang?.cheque_num }}/{{ curLang?.credit_card }}</th>
								<th>
									{{ curLang?.ref }}
								</th>
								<th>
									{{ curLang?.repayment_date }}
								</th>

								<th>
									{{ curLang?.sum }}
								</th>
							</tr>
						</thead>
						<tbody>
							@for (
								invoiceline of finresourceObj.invoicelines;
								track invoiceline
							) {
								<tr>
									<td>
										{{
											curLang[invoiceline.paymentmethod] ||
												invoiceline.paymentmethod
										}}
									</td>
									<td style="width: 30%">
										{{ invoiceline.bank_name }}
										{{
											isEn
												? invoiceline?.creditcard?.name_en
												: invoiceline?.creditcard?.name
										}}
										{{
											isEn
												? invoiceline?.paymentapp?.name_en
												: invoiceline?.paymentapp?.name
										}}
										{{ invoiceline?.branch_name }}
									</td>
									<td>
										{{ invoiceline?.account_num || "" }}
									</td>
									<td>
										{{ invoiceline?.cheque_num }}
										{{ invoiceline?.credit_card_4_digits }}
									</td>
									<td style="font-size: 11px; width: 20%">
										{{ invoiceline?.transaction_id }}
									</td>
									<td>
										{{ invoiceline.repayment_date_display }}
									</td>

									<td class="display-number emp-number">
										{{
											invoiceline.sum - finresourceObj.withholding_tax
												| finNumber
										}}
									</td>
								</tr>
							}
							<tr>
								<td></td>
								<td colspan="4"></td>
								<td></td>
								<td></td>
							</tr>
							@if (finresourceObj?.withholding_tax_percent) {
								<tr>
									<td colspan="5"></td>
									<td>
										{{ curLang?.withholding_tax }}
										{{ finresourceObj.withholding_tax_percent }}% :
									</td>
									<td class="display-number">
										{{ finresourceObj.withholding_tax | finNumber }}
									</td>
								</tr>
							}
							<tr>
								<td colspan="5"></td>
								<td>{{ curLang?.totalMinusvat }} :</td>
								<td class="display-number emp-number">
									{{ finresourceObj.totalMinusvat | finNumber }}
								</td>
							</tr>
							<tr>
								<td colspan="5"></td>
								<td>{{ curLang?.vat }} {{ vatPerc }}% :</td>
								<td class="display-number">
									{{ finresourceObj.vat }}
								</td>
							</tr>

							<tr class="highlight">
								<td colspan="5"></td>
								<td>{{ curLang?.total }} :</td>
								<td class="display-number emp-number">
									{{ finresourceObj.total | finNumber }}
								</td>
							</tr>
						</tbody>
					</table>
				}

				@if (doctype | inArray: ["proforma", "justinvoice"]) {
					<hr class="mb20" />
					<table>
						<tbody>
							<tr class="highlight">
								<td>{{ curLang?.totalMinusvat }} :</td>

								<td class="display-number emp-number">
									{{ finresourceObj.totalMinusvat | finNumber }}
								</td>
							</tr>
							<tr>
								<td>{{ curLang?.vat }} {{ vatPerc }}% :</td>

								<td class="display-number">
									{{ finresourceObj.vat | finNumber }}
								</td>
							</tr>
							<tr class="highlight">
								<td>{{ curLang?.total }} :</td>

								<td class="display-number emp-number">
									{{ finresourceObj.total | finNumber }}
								</td>
							</tr>
						</tbody>
					</table>
				}

				@if (doctype == "prescription") {
					<div style="text-align: left">
						<div style="text-align: left">
							<img src="assets/images/rp.png" />
						</div>
						<table>
							<tbody>
								@for (
									prescriptionLine of finresourceObj.prescriptionLines;
									track prescriptionLine
								) {
									<tr>
										<td>N={{ prescriptionLine.total_amount }}</td>
										<td style="direction: ltr">
											{{ prescriptionLine.amount_output }}
										</td>

										<td>
											{{ prescriptionLine.medic_name }}
										</td>
										<td>
											{{ prescriptionLine.dosage_form }}
										</td>
									</tr>
									<tr>
										<td colspan="5">
											{{ prescriptionLine.remarks }}
											<hr />
										</td>
									</tr>
								}
							</tbody>
						</table>
					</div>
				}

				@if (doctype == "document") {
					<div>{{ finresourceObj.address }}</div>
					<div
						style="line-height: 160%"
						[innerHTML]="
							finresourceObj.html_content_dec || finresourceObj.html_content
								| safeHtml
						"
					></div>
				}
			</div>
		}
		@case ("remarks") {
			@if (finresourceObj.remarks) {
				<div
					[innerHTML]="
						$safeNavigationMigration(curLang?.remarks) +
							': ' +
							(finresourceObj.remarks_dec || finresourceObj.remarks) | safeHtml
					"
				></div>
			}
			@if (finresourceObj.permanent_remarks) {
				<div
					[innerHTML]="
						finresourceObj.permanent_remarks_dec ||
							finresourceObj.permanent_remarks | safeHtml
					"
				></div>
			}
			@if (
				finresourceObj?.current_plus || finresourceObj?.current_plus === "0"
			) {
				<div>
					* {{ curLang?.to_be_paid }} {{ curLang?.current_plus }}
					{{ finresourceObj.current_plus }}
				</div>
			}
		}
		@case ("signature") {
			<div class="sig-text">
				<br />
				<br />
				<br />
				<div [innerHTML]="headtureRow.signature_text | safeHtml"></div>
				@if (headtureRow.signature_logo) {
					<img
						class="logo-img signature-img"
						[src]="headtureRow.id | serverImg: 'headture-signature-logo' : true"
						[alt]="'signature_logo' | langVal"
					/>
				}
				@if (headtureRow.prescription_img) {
					<img
						class="logo-img signature-img"
						[src]="null | serverImg: 'prescription-img' : true"
						[alt]="'prescription_img' | langVal"
					/>
				}

				@if (headtureRow?.signature_text_therapist) {
					<div>
						<div>{{ headtureRow.signature_text_therapist }}</div>
					</div>
				}
			</div>
		}
	}
</ng-template>
@switch (modalProps?.name) {
	@case ("confirm-sms") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="send_sms_proforma1"
			modalWrapperClass="confirm-modal-vert-center modal-narrow-width"
		>
			<app-confirm
				(onClose)="$event ? handleSmsConfirm() : (modalProps = null)"
				[freeText]="modalProps.freeText | langVal"
			/>
		</app-modal-wrap>
	}
	@case ("table-display-contactways") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="contactways"
			modalWrapperClass="modal-800"
		>
			<app-gen-table-display
				(onClose)="
					modalProps = null; $event?.length && handleContactwaysClose($event)
				"
				tableName="contactways"
				[filterField]="modalProps.filterField"
				[filterFieldValue]="finresourceObj[modalProps.filterField]"
				fieldNameInItemToDisplay="contactway"
				isCheckItems
				[preChosenItems]="modalProps.preChosenItems"
				[filterFieldApiObject]="modalProps.filterFieldApiObject"
				[emailsAndPhoneValidation]="modalProps.emailsAndPhoneValidation"
			/>
		</app-modal-wrap>
	}
	@case ("confirm-area-error-close") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="error_changes_will_not_be_saved"
			modalWrapperClass="confirm-modal-vert-center modal-narrow-width"
		>
			<app-confirm
				(onClose)="
					$event
						? handleAreaErrorConfirm(modalProps.sendObj)
						: (modalProps = null)
				"
			/>
		</app-modal-wrap>
	}
	@case ("confirm-save-changes") {
		<app-modal-wrap
			(onClose)="handleSaveChangesConfirm(modalProps.sendObj)"
			title="do_you_want_to_save_changes"
			modalWrapperClass="confirm-modal-vert-center modal-narrow-width"
		>
			<app-confirm
				(onClose)="handleSaveChangesConfirm(modalProps.sendObj, $event)"
			/>
		</app-modal-wrap>
	}
}
